import { ListBlockComponent } from './list-block.js';

export function effects() {
  customElements.define('hive-list', ListBlockComponent);
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-list': ListBlockComponent;
  }
}
